import {toastRequestError} from "_utils/axios";
import {useUrlQuery} from "_utils/url";
import {Address} from "_types/models/Address";

export async function run<T>(promise: Promise<T>, onError: any): Promise<void>;
export async function run<T>(promise: Promise<T>, onSuccess: any, onError: any): Promise<void>;
export async function run<T>(promise: Promise<T>, onSuccess: any, onError?: any) {
    try {
        const result = await promise;

        if (onError === undefined) {
            return;
        }

        onSuccess(result);
    } catch (error) {
        if (onError === undefined && typeof onSuccess === 'function') {
            onSuccess(error);
            return;
        }
        onError(error);
    }
}

export async function toastRun<T>(promise: Promise<T>, onSuccess?: any, whenFinally?: any): Promise<void>;
export async function toastRun<T>(promise: Promise<T>, onSuccess: any = () => {
}, whenFinally: any = () => {
}): Promise<void> {
    const success = (result: T) => {
        onSuccess(result);
        whenFinally();
    }
    const error = (error: any) => {
        toastRequestError(error);
        whenFinally();
    }
    await run(promise, success, error);
}


export function useIsDebugging() {
    const [_, get] = useUrlQuery();
    const isDebug =  get('d') == 'true';

    if (!isDebug) {
        return !!localStorage.getItem('d');
    }

    localStorage.setItem('d', 'true');
    return true;
}

export const fullAddress = (address: Address) => {
    const complement = address.complement ? ` ${address.complement} - `: ' ';
    return `${address.street}, ${address.number},${complement}${address.neighborhood}, ${address.city} - ${address.state}`;
}
